import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

interface DeleteRatingModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteRatingModal = ({ open, onClose, onConfirm }: DeleteRatingModalProps) => {
    return (
        <Modal open={open} closeIcon onClose={onClose} size='small'>
            <Modal.Header>Delete Rating</Modal.Header>
            <Modal.Content>
                Are you sure you want to delete this rating? This action cannot be undone.
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Cancel</Button>
                <Button negative onClick={onConfirm}>
                    Delete
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
